import React from "react";
import { Section } from "../../../atoms/section";
import { Header } from "../../../molecules/header";
import { useStore } from "../../../../store";
import { SECTIONS } from "../../../../constants/sections";
import { SavingsListItem } from "../../../molecules/savings-list-item";
import { Flex } from "../../../atoms/flex";
import { Graph } from "../../../molecules/graph";
import { Wave } from "../../../atoms/wave";
import { UNITS } from "../../../../constants/units";
import { MimboxData } from "../../../../interfaces/mimbox-data";
import { Text } from "../../../atoms/text";

/**
 * Microplastics section component
 */
export const Microplastics = () => {
  const { data = {} as MimboxData, loading } = useStore();
  const {
    microPlasticsSavings = 0,
    microPlasticEmissionsWithoutMimbox = 0,
    microPlasticEmissionsWithMimbox = 0,
  } = data;
  const lowEmissions = microPlasticEmissionsWithMimbox < 1;

  const subTitleWeight =
    microPlasticsSavings > 1000
      ? `${(microPlasticsSavings / 1000).toFixed(1)} ${UNITS.KILO}`
      : `${Math.round(microPlasticsSavings)} ${UNITS.GRAMS}`;
  return (
    <>
      <Wave className="fill-white" variant={2} />
      <Section className="bg-white" id={SECTIONS.MICROPLASTICS} wave>
        <Header
          icon="microplastics"
          title={SECTIONS.MICROPLASTICS}
          subTitle={`${subTitleWeight} minskat utsläpp, en minskning på ${data?.microPlasticReductionInPercent}${UNITS.PERCENT}`}
          loading={loading}
        ></Header>
        <Flex className="section-content">
          <Flex className="savings-list">
            <SavingsListItem
              text="Antalet tvättar sedan mimboxen installerats."
              value={Math.round(data?.numberOfWashes || 0)}
              unit={UNITS.PER_UNIT}
              loading={loading}
            />
            <SavingsListItem
              text="Antal mikroplaster som släpps per tvätt."
              value="700 000"
              unit={UNITS.PER_UNIT}
              loading={loading}
            />
            <SavingsListItem
              text="Genomsnittlig vikt på mikroplaster som släpps per tvätt."
              value="1,3"
              unit={UNITS.GRAMS}
              loading={loading}
            />
            <Text className="text-reference" align="right" fontStyle="italic">
              **Siffror framtagna från “Polyester Textiles as a Source of
              Microplastics from Households, 2017”
              https://pubs.acs.org/doi/10.1021/acs.est.7b01750
            </Text>
          </Flex>
          <Graph
            description="Mikroplastutsläpp"
            max={
              lowEmissions
                ? microPlasticEmissionsWithoutMimbox * 1000
                : microPlasticEmissionsWithoutMimbox
            }
            min={
              lowEmissions
                ? microPlasticEmissionsWithMimbox * 1000
                : microPlasticEmissionsWithMimbox
            }
            unit={lowEmissions ? UNITS.GRAMS : UNITS.KILO}
            loading={loading}
          />
        </Flex>
      </Section>
    </>
  );
};
